// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2QiDb","boxTitle":"Qualiphy_boxTitle__1Z3jP","box":"Qualiphy_box__SfkfZ","toggleWrap":"Qualiphy_toggleWrap__9p0BM"};